import { Box } from "@oneloop/jopijs";
import React, { useEffect, useState } from "react";
import style from "./imagesEdition.module.scss";
import CardEdition from "./CardEdition";

export default function ImagesGalleryEdition({
  allImages = [],
  allBlueprints = [],
  originFrontCover = {},
  editedImages = [],
  editedBlueprints = [],
  frontCover,
  handleEditedImages,
}) {
  const [editedImg, setEditedImg] = useState(editedImages);
  const [editedBp, setEditedBp] = useState(editedBlueprints);
  const [frontCov, setFrontCov] = useState(
    frontCover || { url: "", is_blueprint: false }
  );
  const allImagesCopy = allImages.slice();
  const allBlueprintsCopy = allBlueprints.slice();
  const orderEditedImages = (originImages, editableImages) => {
    const editableImagesCopy = editableImages.slice();
    const indiceMap = new Map();
    originImages.forEach((url, index) => {
      indiceMap.set(url, index);
    });
    editableImagesCopy.sort((a, b) => {
      const indiceA = indiceMap.get(a);
      const indiceB = indiceMap.get(b);
      return indiceA - indiceB;
    });
    return editableImagesCopy;
  };
  useEffect(() => {
    handleEditedImages({
      images: orderEditedImages(allImages, editedImg),
      blueprints: orderEditedImages(allBlueprints, editedBp),
      front_cover_image: frontCov,
    });
  }, [editedImg, editedBp, frontCov]);

  const handleChange = (checked, file, type) => {
    if (checked) {
      if (type === "images") {
        if (editedImg.length === 0 && frontCov.url === "") {
          setFrontCov({ url: file, is_blueprint: false });
        } else setEditedImg([...editedImg, file]);
      }
      if (type === "blueprints") {
        if (editedBp.length === 0 && frontCov.url === "") {
          setFrontCov({ url: file, is_blueprint: true });
        } else setEditedBp([...editedBp, file]);
      }
    }
    if (!checked) {
      if (file === frontCov.url) {
        let otherImages = [];
        if (editedImg[0]) otherImages = orderEditedImages(allImages, editedImg);
        if (!editedImg[0] && editedBp[0])
          otherImages = orderEditedImages(allBlueprints, editedBp);

        const newMain = otherImages[0] ?? "";
        const newData = otherImages.filter((img) => img !== newMain);
        setFrontCov({ url: newMain, is_blueprint: !editedImg[0] });
        if (editedImg[0]) {
          setEditedImg(newData);
        }
        if (!editedImg[0] && editedBp[0]) {
          setEditedBp(newData);
        }
      } else {
        if (type === "blueprints") {
          const newData = editedBp.filter((el) => el !== file);
          setEditedBp(newData);
        }
        if (type === "images") {
          const newData = editedImg.filter((el) => el !== file);
          setEditedImg(newData);
        }
      }
    }
  };
  const isCheked = (edited_data, file) =>
    edited_data.includes(file) || frontCov.url === file;

  const handleMainSelect = (type, file) => {
    const newImages = [...editedImg];
    const newBlueprints = [...editedBp];

    if (frontCov.url !== "") {
      if (!frontCov.is_blueprint) {
        newImages.unshift(frontCov.url);
      } else {
        newBlueprints.unshift(frontCov.url);
      }
    }
    setEditedImg(
      type === "images" ? newImages.filter((el) => el !== file) : newImages
    );
    setEditedBp(
      type === "blueprints"
        ? newBlueprints.filter((el) => el !== file)
        : newBlueprints
    );
    setFrontCov({ url: file, is_blueprint: type === "blueprints" });
  };

  if (originFrontCover?.url && !originFrontCover?.is_blueprint) {
    allImagesCopy.unshift(originFrontCover.url);
  } else if (originFrontCover?.url && originFrontCover?.is_blueprint) {
    allBlueprintsCopy.unshift(originFrontCover.url);
  }
  return (
    <Box>
      <Box className={style.imagesContainer}>
        {allImagesCopy.map((img) => (
          <CardEdition
            file={img}
            key={img}
            handleChange={handleChange}
            handleMainSelect={handleMainSelect}
            main={frontCov.url === img}
            check={isCheked(editedImg, img)}
            type="images"
            data-testid="images-card"
          />
        ))}
        {allBlueprintsCopy.map((img) => (
          <CardEdition
            file={img}
            key={img}
            handleChange={handleChange}
            handleMainSelect={handleMainSelect}
            check={isCheked(editedBp, img)}
            main={frontCov.url === img}
            type="blueprints"
          />
        ))}
      </Box>
    </Box>
  );
}
